<template>
    <div>
        <b-modal size="xl" id="edit-result-table" title="Hatalı Verileri Düzenle" scrollable no-close-on-esc no-close-on-backdrop>
            <draft-price-edit-result-table v-model="c_resultTableValidAndInValid"></draft-price-edit-result-table>
            <template #modal-footer><v-executer :loading="calculating" :text="calculating? 'Hesaplanıyor... Bu işlem uzun sürebilir.':'Hesapla ve Ekle'" :action="calculateDistances"></v-executer></template>
        </b-modal>

        <div class="row">
            <div class="col-md-12 mb-1">
                <label class="form-label">Referans Model</label>
                <v-select-list multiple :options="c_referenceModels" label="VehicleReferenceModelManuelName" v-model="referenceModel" placeholder="Referans Model"></v-select-list>
            </div>
            <div class="col-md-12 mb-1">
                <b-form-checkbox v-model="isAvoidTolls" inline>Paralı Yolları Dahil Et</b-form-checkbox>
                <b-form-checkbox v-model="isAvoidHighways" inline>Anayolları Dahil Et</b-form-checkbox>
            </div>
            <div class="col-md-12 text-right mb-1">
                <button class="btn btn-flat-success" v-on:click="getSample">
                    <feather-icon icon="FileIcon"></feather-icon>
                    Örnek Excel
                </button>
            </div>
            <div class="col-md-12">
                <v-file-uploader :disabled="referenceModel.length == 0" :accept="['xls','xlsx']" v-model="file" v-on:change="file = $event"></v-file-uploader>
                <v-executer full-width class="mt-50" variant="secondary" :loading="excelLoading || calculating" :action="sendExcel" text="Kontrol Et" :disabled="!file"></v-executer>
            </div>
        </div>
        <div class="row" v-if="file && resultFile && c_resultTableValidAndInValid.InValid.length != 0">
            <div class="col-md-6">
                <div class="alert alert-danger mt-1 mb-0">
                    <div class="alert-body">
                        <div class="row align-items-center">
                            <div class="col-md">
                                Hatalı verileri excel üzerinde düzeltebilirsiniz.
                            </div>
                            <div class="col-md-auto">
                                <div class="text-right">
                                    <button class="btn btn-danger" v-on:click="getResultExcel">
                                        <feather-icon icon="FileIcon"></feather-icon>
                                        Hatalı Excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="alert alert-primary mt-1 mb-0">
                    <div class="alert-body">
                        <div class="row align-items-center">
                            <div class="col-md">
                                Hatalı verileri tablo üzerinde düzeltebilirsiniz.
                            </div>
                            <div class="col-md-auto">
                                <div class="text-right">
                                    <button :disabled="referenceModel.length == 0" class="btn btn-primary" v-on:click="$showModal('edit-result-table')">Düzenle</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CalculatePriceApi from '@/api/calculate-price'
import {BFormCheckbox} from 'bootstrap-vue'
import VFileUploader from '@/components/v-file-uploader/VFileUploader'
import DraftPriceEditResultTable from '@/views/calculate-price/draft-price/components/DraftPriceEditResultTable'
import GoogleMaps from '@/utilities/google-maps'
import randomatic from 'randomatic'
import Additional from '@/utilities/additional'

export default {
    components:{
        BFormCheckbox,
        VFileUploader,
        DraftPriceEditResultTable
    },
    props:{
        value:Object,
        oneDayKm:Number,
    },
    data() {
        return {
            referenceModels: [],
            referenceModel: [],
            isAvoidTolls:false,
            isAvoidHighways:false,
            file:null,
            resultFile:null,
            resultTable:[],
            excelLoading:false,
            calculating:false,
            searchValue:""   
        }
    },
    watch:{
        file(){
            this.resultFile = null
            this.resultTable = []
        }
    },
    mounted(){
        this.getReferenceModels()
    },
    methods:{
        clearForm(){
            this.referenceModel = []
            this.file = null
        },
        getSample(){
            CalculatePriceApi.DraftPrice.GetSampleExcel().then(res=>{
                Additional.DownloadFile(res.data, 'TeklifKonumlari.xlsx')
            })
        },
        getResultExcel(){
            CalculatePriceApi.DraftPrice.GetResultExcel(this.resultFile).then(res=>{
                Additional.DownloadFile(res.data, 'HatalıTeklifKonumlari.xlsx')
            })
        },
        getReferenceModels(){
            CalculatePriceApi.ReferenceModel.List()
            .then(res=>{
                this.referenceModels = res.data.Data
            })
        },
        sendExcel(){
            this.excelLoading = true
            var formData = new FormData()
            formData.append('File', this.file)
            CalculatePriceApi.DraftPrice.UploadExcel(formData).then(res=>{
                if(res.data.Success){
                    this.resultFile = res.data.Data.FilePath
                    this.resultTable = res.data.Data.Values
                    this.resultTable.forEach(item=> item.Id = randomatic('A0',10))
                    if(this.c_resultTableValidAndInValid.InValid.length == 0){
                        this.calculateDistances()
                    }
                }else{
                    this.$result(res)
                }
                this.excelLoading = false
            }).catch(err=>{
                this.$result(null,err)
                this.excelLoading = false
            })
        },
        calculateDistances(){
            this.value.UncalculatedRoutes.forEach(ucr=>{ this.$set(ucr,"selected",false) } )
            this.calculating = true
            const list = this.c_resultTableValidAndInValid.Valid.map(er=>{
                return {
                    StartProvinceId:er.StartProvinceModel.Id,
                    StartProvinceName:er.StartProvinceModel.Name,
                    StartDistrictId:er.StartDistrictModel.Id,
                    StartDistrictName:er.StartDistrictModel.Name,
                    EndProvinceId:er.EndProvinceModel.Id,
                    EndProvinceName:er.EndProvinceModel.Name,
                    EndDistrictId:er.EndDistrictModel.Id,
                    EndDistrictName:er.EndDistrictModel.Name,
                    Tolls:this.isAvoidTolls,
                    Highways:this.isAvoidHighways,
                    CustomerKm:er.CustomerKm,
                    CountOfTrips:1
                }
            })
            CalculatePriceApi.DraftPrice.CalculateDistanceMultiple(list).then(res=>{
                if(res.data.Success){
                    this.calculating = false
                    res.data.Data?.forEach(d=>{
                        this.referenceModel.forEach(rm => {
                            let route = this.uncalculatedData(d,'Excel',rm,this.oneDayKm)
                            this.value.UncalculatedRoutes.push(route)
                        })
                    })
                    this.clearForm()
                    this.$hideModal("edit-result-table")
                }else{
                    this.$result(res)
                }
            }).catch(err=>{
                this.calculating = false
                this.$result(null,err)
            })
        },
        uncalculatedData(data,type,rm,oneDayKm){
            return {
                id:randomatic("A0",10),
                selected:false,
                startProvince: data.StartProvinceId ? { Id:data.StartProvinceId, Name:data.StartProvinceName } : null,
                startDistrict: data.StartDistrictId ? { Id:data.StartDistrictId, Name:data.StartDistrictName } : null,
                startNeighborhood: data.StartNeighborhoodId ? { Id:data.StartNeighborhoodId, Name:data.StartNeighborhoodName } : null,
                endProvince: data.EndProvinceId ? { Id:data.EndProvinceId, Name:data.EndProvinceName } : null,
                endDistrict: data.EndDistrictId ? { Id:data.EndDistrictId, Name:data.EndDistrictName } : null,
                endNeighborhood: data.EndNeighborhoodId ? { Id:data.EndNeighborhoodId, Name:data.EndNeighborhoodName } : null,
                customerKm:data.CustomerKm,
                isAvoidTolls:data.Tolls,
                isAvoidHighways:data.Highways,
                referenceModel:rm,
                countOfTrips:data.CountOfTrips,
                countOfDaysWorked:Math.ceil(data.Distance/oneDayKm),
                type:type,
                calculatedDistance: data.Distance
            }
        },
    },
    computed:{
        c_resultTableValidAndInValid(){
            return {
                Valid: this.resultTable.filter(rt=>{
                    return rt.StartProvinceModel.IsValid == true 
                    && rt.EndProvinceModel.IsValid == true
                    && rt.StartDistrictModel.IsValid == true
                    && rt.EndDistrictModel.IsValid == true
                }),
                InValid: this.resultTable.filter(rt=>{
                    return rt.StartProvinceModel.IsValid == false 
                    || rt.EndProvinceModel.IsValid == false
                    || rt.StartDistrictModel.IsValid == false
                    || rt.EndDistrictModel.IsValid == false
                })
            }
        },
        c_referenceModels(){
            if(this.referenceModel.length > 0){
                const first = this.referenceModel[0]
                return this.referenceModels.filter(rm => rm.GroupNumber == first.GroupNumber)
            }else return this.referenceModels
        }
    }
}
</script>

<style>

</style>